<div [class.main-content]="mode == 'leads'" [ngStyle]="{ direction: pageDirection }">
  <div class="leads-header">
    <h2 *ngIf="mode == 'leads'">{{ "appointments.gui.labels.leads.Leads" | translate }}</h2>
    <h2 *ngIf="mode == 'messages'">{{ "appointments.gui.labels.messages set by patients" | translate }}</h2>
    <button *ngIf="mode == 'leads'" class="add-lead-btn" (click)="openNewLead()">
      <span class="add-lead-plus">+</span>
      {{ "appointments.gui.labels.leads.New Lead" | translate }}
    </button>
  </div>

  <div class="flex gap-4 items-center mb-4 flex-wrap">
    <div>
      <strong style="margin-inline-end: 0.5em">{{ "appointments.gui.labels.From" | translate }}:</strong>
      <input
        [matDatepicker]="fromPicker"
        [(ngModel)]="filters.from"
        class="t-field t-field--date menstural-field"
        (click)="fromPicker.open()"
        style="margin-inline-end: 1em"
      />
      <mat-datepicker #fromPicker></mat-datepicker>
      <strong style="margin-inline-end: 0.5em">{{ "appointments.gui.labels.Until" | translate }}:</strong>
      <input
        [matDatepicker]="toPicker"
        [(ngModel)]="filters.to"
        (click)="toPicker.open()"
        class="t-field t-field--date menstural-field"
        style="margin-inline-end: 1em"
      />
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
    <select class="t-field" [(ngModel)]="filters.status" (ngModelChange)="load()">
      <option value="all">{{ "appointments.gui.labels.leads.Status All" | translate }}</option>
      <option value="pending">{{ "appointments.gui.labels.leads.Status Pending" | translate }}</option>
      <option value="handled">{{ "appointments.gui.labels.leads.Status Handled" | translate }}</option>
    </select>
    <select class="t-field" [(ngModel)]="filters.source" (ngModelChange)="load()">
      <option value="all">{{ "appointments.gui.labels.leads.Source All" | translate }}</option>
      <option value="manual">{{ "appointments.gui.labels.leads.Source Manual" | translate }}</option>
      <option value="selfBooking">{{ "appointments.gui.labels.leads.Source Self Booking" | translate }}</option>
    </select>
    <select *ngIf="mode == 'leads'" class="t-field" [(ngModel)]="filters.leadType" (ngModelChange)="load()">
      <option value="all">{{ "appointments.gui.labels.leads.Type All" | translate }}</option>
      <option value="manual">{{ "appointments.gui.labels.leads.Type Manual" | translate }}</option>
      <option value="waitingList">{{ "appointments.gui.labels.leads.Type Waiting List" | translate }}</option>
      <option value="abandoned">{{ "appointments.gui.labels.leads.Type Abandoned" | translate }}</option>
    </select>
    <button mat-button color="primary" class="blue-btn" (click)="load()">
      {{ "appointments.gui.buttons.Filter" | translate }}
    </button>
    <button mat-button color="warn" class="orange-btn" (click)="clearFilters()">
      {{ "appointments.gui.buttons.Clear Filter" | translate }}
    </button>
    <button>
      <img
        style="cursor: pointer"
        [matTooltip]="'appointments.gui.tooltips.Download CVS' | translate"
        (click)="exportExcel()"
        height="31em"
        width="31em"
        src="../../assets/icons/fileblue.svg"
      />
    </button>
  </div>

  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div class="search-results" *ngIf="!loading">
    <table *ngIf="leads && leads.length">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ "appointments.gui.labels.patient name" | translate | titlecase }}</th>
          <th>{{ "appointments.gui.labels.Mobile" | translate }}</th>
          <th>{{ "appointments.gui.labels.Email" | translate }}</th>
          <th>{{ "billing.gui.placeholders.ID Number" | translate }}</th>
          <th>{{ "billing.gui.labels.Creation Date" | translate }}</th>
          <th>{{ "appointments.gui.labels.leads.Created By" | translate }}</th>
          <th>{{ "appointments.gui.labels.leads.Type" | translate }}</th>
          <th>{{ "appointments.gui.labels.leads.Abandon Stage" | translate }}</th>
          <th>{{ "appointments.gui.labels.message" | translate }}</th>
          <th>{{ "appointments.gui.labels.leads.Note" | translate }}</th>
          <th>{{ "appointments.gui.labels.Payer" | translate }}</th>
          <th>{{ "billing.gui.labels.Exam Name" | translate }}</th>
          <th>{{ "appointments.gui.labels.leads.Handled" | translate }}</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lead of leads; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ lead.First }} {{ lead.Last }}</td>
          <td>{{ lead.Mobile }}</td>
          <td>{{ lead.Email }}</td>
          <td>{{ lead.ID }}</td>
          <td>{{ lead.creationTime | date : "dd.MM.yyyy HH:mm" }}</td>
          <td>{{ createdByText(lead) }}</td>
          <td>{{ typeKey(lead.LeadType) | translate }}</td>
          <td>
            <ng-container *ngIf="stageKey(lead.AbandonStage) as key; else rawStage">{{ key | translate }}</ng-container>
            <ng-template #rawStage>{{ lead.AbandonStage }}</ng-template>
          </td>
          <td style="max-width: 18em">{{ lead.Message }}</td>
          <td style="min-width: 14em">
            <ng-container *ngIf="editingNoteLeadId != lead.AutoIndex">
              <span class="note-text">{{ lead.Note }}</span>
              <button
                class="note-btn"
                [matTooltip]="(lead.Note ? 'appointments.gui.labels.leads.Edit Note' : 'appointments.gui.labels.leads.Add Note') | translate"
                (click)="startEditNote(lead)"
              >
                {{ lead.Note ? "✎" : "+" }}
              </button>
            </ng-container>
            <ng-container *ngIf="editingNoteLeadId == lead.AutoIndex">
              <textarea class="t-field lead-note" rows="3" [(ngModel)]="noteDraft"></textarea>
              <div>
                <button class="blue-btn" (click)="saveNote(lead)">{{ "appointments.gui.buttons.Save" | translate }}</button>
                <button class="orange-btn" (click)="cancelEditNote()">{{ "appointments.gui.buttons.Cancel" | translate }}</button>
              </div>
            </ng-container>
          </td>
          <td>{{ lead.HMO ? ("appointments.gui.labels." + lead.HMO | translate) : "" }}</td>
          <td>{{ lead.ExamType }}</td>
          <td>
            <input type="checkbox" [checked]="lead.Handled" (change)="toggleHandled(lead)" />
          </td>
          <td>
            <ng-container *ngIf="!lead.existingPID">
              <button
                class="orange-btn"
                style="height: fit-content"
                *ngIf="creatingPatientLeadId != lead.AutoIndex"
                (click)="startCreatePatient(lead)"
              >
                {{ "appointments.gui.buttons.create patient" | translate }}
              </button>
              <ng-container *ngIf="creatingPatientLeadId == lead.AutoIndex">
                <input
                  *ngIf="!lead.ID"
                  class="t-field"
                  [(ngModel)]="idByLead[lead.AutoIndex]"
                  [placeholder]="'billing.gui.placeholders.ID Number' | translate"
                />
                <input
                  [matDatepicker]="birthPicker"
                  [(ngModel)]="birthByLead[lead.AutoIndex]"
                  (click)="birthPicker.open()"
                  class="t-field t-field--date menstural-field"
                  [placeholder]="'appointments.gui.labels.Birth Date' | translate"
                />
                <mat-datepicker #birthPicker></mat-datepicker>
                <button class="blue-btn" [disabled]="!canConfirmPatient(lead)" (click)="confirmCreatePatient(lead)">
                  {{ "appointments.gui.buttons.Save" | translate }}
                </button>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="lead.existingPID">
              <p>{{ "appointments.gui.labels.patient exist" | translate }}</p>
              <button class="blue-btn go-patient-btn" (click)="goToPatient(lead)">
                {{ "appointments.gui.labels.leads.Go To Patient" | translate }}
              </button>
            </ng-container>
          </td>
          <td class="pointer">
            <img
              src="../../assets/icons/delete-blue.svg"
              [matTooltip]="'billing.gui.buttons.Delete' | translate"
              (click)="deleteLead(lead)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
